import flatpickr from "flatpickr"
import { German } from "flatpickr/dist/l10n/de.js"

flatpickr(".date-picker", {
    altInput: true,
    altFormat: 'd.m.Y',
    dateFormat: 'Y-m-d',
    locale: 'de',
    disableMobile: true
});